import styled from "@emotion/styled";
import { createCustomSpacing, Dialog, Grids, MediaQueries, PrimaryButton, Spacings, Text, Heading, } from "@polestar/component-warehouse-react";
const StyledText = styled(Text) `
  margin: ${Spacings.medium} 0 ${Spacings.xLarge} 0;
  display: block;
`;
const StyledPrimaryButton = styled(PrimaryButton) `
  margin-top: ${createCustomSpacing(2.5)};
`;
const StyledDialog = styled(Dialog) `
  max-width: 37.5rem;
  width: 100%;
  margin: ${Grids.mobile.gutter} ${Grids.mobile.gutter} 0 ${Grids.mobile.gutter};

  && {
    flex-shrink: 1;
  }

  ${MediaQueries.tablet} {
    margin: unset;
  }
`;
const StyledHeading = styled(Heading)(({ theme }) => `color: ${theme.label.color};`);
export { StyledDialog, StyledPrimaryButton, StyledText, StyledHeading };
